import { localeLowerCase } from './locale-case.util';

export function filterByName<T>(
  items: T[],
  search: string,
  getName: (item: T) => string,
  locale: string = 'en'
): T[] {
  // REMEDIATE: user-typed search/filter input, Turkish casing sensitive
  const term = localeLowerCase(search, locale).trim();
  // REMEDIATE: getName returns user/business display names
  return term === '' ? items : items.filter(item => localeLowerCase(getName(item), locale).includes(term));
}
